import { render, staticRenderFns } from "./MonitorIndex.vue?vue&type=template&id=44d189d9&scoped=true&"
import script from "./MonitorIndex.vue?vue&type=script&lang=ts&"
export * from "./MonitorIndex.vue?vue&type=script&lang=ts&"
import style0 from "./MonitorIndex.vue?vue&type=style&index=0&id=44d189d9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d189d9",
  null
  
)

export default component.exports